import get from 'lodash/get';
import createPromiseThunk from "~/rx/lib/createPromiseThunk";
import isArray from 'lodash/isArray';
import identify from "~/identify";

const createSuccessPromiseThunk = ({successHandler, prefix, ...params}) => {
    let successPath = prefix ? `${prefix}.success` : 'success',
        messagePath = prefix ? `${prefix}.messages` : 'messages';

    let thunkHandler = createPromiseThunk({
        ...params,
        successHandler: successHandler || (({dispatch, value, setValue, setErrored, customParams}) => {
            if(get(value, successPath)) {
                dispatch(setValue(value, customParams));
            } else {
                let messageError = get(value, messagePath);
                if(messageError) {
                    dispatch(setErrored(messageError, customParams));
                    return true;
                }

                dispatch(setErrored(messageError, customParams));
            }

            return true;
        })
    });

    let originalReduce = thunkHandler.reduce;
    thunkHandler.reduce = (state, action) => {
        switch(action.type) {
            case thunkHandler.types.ERROR:
                if(!isArray(action.error)) {
                    return originalReduce(state, action);
                }

                let errorState = {
                    ...state,
                    status: identify.STATUS_ERRORED,
                    finished_at: Date.now(),
                    error: "fetchItem_errored" !== action.type ? false : action.error,
                    value: {
                        ...state.value,
                        messages: action.error
                    }
                };

                return errorState;
            default:
                return originalReduce(state, action)
        }
    };

    return thunkHandler;
};

export default createSuccessPromiseThunk;